<template>
  <a-spin :spinning="confirmLoading">
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="6">
            <a-form-item :label="$t('label.numberOfSlaughter')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outQty', validatorRules.outQty]" placeholder="请输入出栏数量(羽）" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="合同数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['conQty', validatorRules.conQty]" placeholder="请输入合同数量(羽）" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="重量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outWeight', validatorRules.outWeight]" placeholder="请输入重量（kg）" style="width: 84%"/> kg
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="扣减重量 " :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  v-decorator="['outWeightDeduction', validatorRules.outWeightDeduction]" placeholder="请输入扣减重量 " style="width: 84%"/> kg
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.amount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outAmount', validatorRules.outAmount]" placeholder="请输入金额（元）" style="width: 84%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.averageUnitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outAvgUnit', validatorRules.outAvgUnit]" placeholder="请输入平均单价（元/kg)" style="width: 84%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="折算出栏量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outConvertedNumber']" placeholder="请输入折算出栏量" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="标准体重" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['stdWeight', validatorRules.stdWeight]" placeholder="请输入标准体重" style="width: 84%"/> kg
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item v-has="'conCode'" :label="$t('label.contracts')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-form-container>
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
    <a-tab-pane tab="出栏明细" :key="refKeys[0]" :forceRender="true">
    <j-editable-table
      :ref="refKeys[0]"
      :loading="efsMktListTable.loading"
      :columns="efsMktListTable.columns"
      :dataSource="efsMktListTable.dataSource"
      :maxHeight="300"
      :disabled="formDisabled"
      :rowNumber="true"
      :rowSelection="true"
      :actionButton="false"/>
  </a-tab-pane>
  </a-tabs>
  </a-spin>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'

  export default {
    name: 'ColumnInfoForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,

    },
    props:{
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
          outQty: {
            rules: [
              { required: false},
              { pattern: /^-?\d+$/, message: '请输入整数!'},
            ]
          },
          conQty: {
            rules: [
              { required: false},
              { pattern: /^-?\d+$/, message: '请输入整数!'},
            ]
          },
          outWeight: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          outWeightDeduction: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          outAmount: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          outAvgUnit: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          stdWeight: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
        },
        refKeys: ['efsMktList', ],
        tableKeys:['efsMktList', ],
        activeKey: 'efsMktList',
        // efs_mkt_list
        efsMktListTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '出栏编码',
              key: 'soCode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '出栏日期',
              key: 'releaseTime',
              type: FormTypes.date,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.unitPrice'),
              key: 'actSettlePrice',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '出栏总量',
              key: 'totalReleaseQty',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '出栏总重',
              key: 'totalReleaseWeight',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '出栏均重',
              key: 'releaseAvgWeight',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '金额',
              key: 'totalCost',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        url: {
          efsMktList: {
            list: '/newContractManage/efsMdContract/queryEfsMktListByMainId'
          },
        }
      }
    },

    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      }
    },
    methods:{
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      edit(record){
        this.model = Object.assign({}, record)
        console.log("ColumnInfoForm-edit",this.model);
        let fieldval = pick(this.model,'conCode','outQty','conQty','outWeight','outWeightDeduction','outAmount','outAvgUnit','outConvertedNumber','stdWeight')
        if (this.model.id) {
          let params = { conCode: this.model.conCode }
          this.requestSubTableData(this.url.efsMktList.list, params, this.efsMktListTable)
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError","结算单详情表单校验未通过");
          }
        })
        console.log("结算单详情表单数据集",formdata_arr);
        return formdata_arr;
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'conCode','outQty','conQty','outWeight','outWeightDeduction','outAmount','outAvgUnit','outConvertedNumber','stdWeight'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
    }
  }
</script>
